import { WeekHoursItem } from '../../../components/weekhours-editor'
import { NewRestrictionPlanItem } from '../../../stores/restriction-plans-store'

export interface RestrictionPlanFormItem {
	displayName: string
	hourRestrictions: WeekHoursItem
}

export function getWeekHoursItem(item: NewRestrictionPlanItem) {
	var weekHoursItem = {
		minhours: [
			item.mondayMinHours,
			item.tuesdayMinHours,
			item.wednesdayMinHours,
			item.thursdayMinHours,
			item.fridayMinHours,
			item.saturdayMinHours,
			item.sunMinHours,
			item.weekMinHours
		],
		maxhours: [
			item.mondayMaxHours,
			item.tuesdayMaxHours,
			item.wednesdayMaxHours,
			item.thursdayMaxHours,
			item.fridayMaxHours,
			item.saturdayMaxHours,
			item.sunMaxHours,
			item.weekMaxHours
		]
	}
	weekHoursItem.maxhours = weekHoursItem.maxhours.map(i => i ?? 24)
	weekHoursItem.minhours = weekHoursItem.minhours.map(i => i ?? 24)
	weekHoursItem.minhours[7] = (weekHoursItem.minhours as number[]).reduce((a, b, i) => (i < 7) ? a + b : a)
	weekHoursItem.maxhours[7] = (weekHoursItem.maxhours as number[]).reduce((a, b, i) => (i < 7) ? a + b : a)
	return weekHoursItem as WeekHoursItem
}

export function getPlanHourRestrictions(minhours: number[], maxhours: number[]) {
	return {
		mondayMinHours:    minhours[0],
		tuesdayMinHours:   minhours[1],
		wednesdayMinHours: minhours[2],
		thursdayMinHours:  minhours[3],
		fridayMinHours:    minhours[4],
		saturdayMinHours:  minhours[5],
		sunMinHours:       minhours[6],
		weekMinHours:      minhours[7],
		mondayMaxHours:    maxhours[0],
		tuesdayMaxHours:   maxhours[1],
		wednesdayMaxHours: maxhours[2],
		thursdayMaxHours:  maxhours[3],
		fridayMaxHours:    maxhours[4],
		saturdayMaxHours:  maxhours[5],
		sunMaxHours:       maxhours[6],
		weekMaxHours:      maxhours[7]
	}
}

export function formItemToRestrictionPlanItem(formItem: any) {
	const { displayName, hourRestrictions } = formItem
	const { minhours, maxhours } = hourRestrictions
	return ({
		displayName,
		...getPlanHourRestrictions(minhours, maxhours)
	})
}
